__turbopack_context__.v({
  "chartLabels": "_281FJW_chartLabels",
  "monthLabelSpacer": "_281FJW_monthLabelSpacer",
  "rowLabel": "_281FJW_rowLabel",
  "snowHeightLabels": "_281FJW_snowHeightLabels",
});
